export default {
    app_config: [],
    adm_config: [],
    config: []
}